import { render, staticRenderFns } from "./CasesTable.vue?vue&type=template&id=23d424e0&scoped=true&"
import script from "./CasesTable.vue?vue&type=script&lang=js&"
export * from "./CasesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d424e0",
  null
  
)

export default component.exports